export default {
    '行情': 'مارکیٹ',
    '了解最新行情和交易大数据': 'د مارکیٹ وروستي حالت او د سوداګرۉ لوی معلومات په اړه پوهیږئ',
    '热门榜': 'مشهور لیست',
    '新币榜': 'نوي اسعارو لیست',
    '涨幅榜': 'د زیاتوالي لیست',
    '热门合约': 'مشهور تړونونه',
    '交易': 'سوداګري',
    '现货交易': 'د سپټ سوداګري',
    '币币闪兑': 'د اسعارو تبادله، چټکه سوداګري',
    '搜索': 'لټون',
    '主流币': 'اصلي اسعار',
    '热门': 'مشهور',
    '合约': 'تړون',
    '永续': 'تلپاتې',
    '灵活杠杆': 'انعطاف پذیر لیورج، لوړ عاید',
    '金融业务': 'مالي چارې',
    '店铺展示': 'د پلورنځي ښودنه',
    '门店编号': 'د پلورنځي شمیره',
    '城市': 'ښار',
    '地址': 'پته',
    'show1': 'تر 2030 کال پورې، د Crocodile د همکارۍ پلورنځي شمیرې 100,000 ته رسېږي.',
    'show2': 'هر پلورنځی ریښتینی، خپلواک ID لري، هرڅه ریښتینی، باوري، عام او روښانه دي!',
    'show3': 'کریپټو اسعار × ټولنیز خدمتونه × د همکارۍ ګټه',
    'show4': 'د Crocodile Exchange د همکارۍ پلورنځي پروګرام · د سیمه ییز سوداګریز نوي اکوسیستم جوړول',
    '优质项目起飞的地方': 'د عالي پروژو د پیل ځای',
    '解锁潜质代币': 'د بالقوه ټوکنونو خلاصول',
    '定期挖矿': 'منظم ماینینګ',
    '更多个性化选择': 'نور شخصي انتخابونه',
    '暂无数据': 'اوس مهال هیڅ معلومات نشته',
    '探索数字资产的无限可能': 'د ډیجیټل شتمنیو د نامحدود امکانونو کشف',
    '更多下载选择': 'د ډاونلوډ نور انتخابونه',
    '注册': 'نوملیکنه',
    '开始': 'پیل',
    "立即注册，免费创建自己的作品集！": "همالته نوملیکنه وکړئ، وړیا خپل پورټفولیو جوړ کړئ!",
    '布局未来，现在开始': 'د راتلونکي طرحه، اوس پیل کړئ',
    '邮箱': 'ایمیل/تلیفون',
    '把握交易良机': 'د سوداګرۉ ښه فرصت ونیسئ',
    '市场行情': "د بازار حالت",
    "热门衍生品": "مشهور مشتقات",
    "热门代币": "مشهور ټوکنونه",
    '主流榜': 'اصلي لیست',
    '现货新币榜': 'د سپټ نوي اسعارو لیست',
    '合约新币榜': 'د تړون نوي اسعارو لیست',
    '交易对': 'د سوداګرۉ جوړه',
    '最新价': 'وروستي قیمت',
    '涨跌幅': 'د قیمت بدلون',
    '走势图': "د حرکت گراف",
    '成交量': 'د سوداګرۉ حجم',
    '操作': 'عملیات',
    '待上币种': 'د پلیښو په تمه اسعار',
    '上线时间': 'د پیل وخت',
    '开盘倒计时': 'د پیل کاونټ ډاون',
    '已上币种': 'پیل شوي اسعار',
    '下载应用': 'اپلیکیشن ډاونلوډ کړئ',
    '随时随地': 'هرچیرې او هر وخت سوداګري پیل کړئ',
    '受千万用户信赖的加密货币交易所': 'د میلیونونو کاروونکو په باور کریپټوکرنسي بورس',
    '强大的交易体验': 'قوي د سوداګرۉ تجربه',
    '提供多种加密货币交易': 'مختلف کریپټوکرنسي سوداګرۉ وړاندیز کوي، چې سپټ، تړون، تعقیب او نور محصولات پکې شامل دي، د ګڼ شمیر پانګونې اړتیاوې پوره کوي',
    '全天服务': '7*24 ساعت خدمت',
    '提供全天候服务': 'مسلکي ملاتړي 24 ساعته آنلاین دي، د کاروونکو پوښتنو ته ځواب وايي',
    '安全合规': 'امنیت او مطابقت',
    '顶级安全风控体系': 'د لوړې کچې امنیتي کنټرول سیسټم، په ګڼو سیمو کې مطابقت لري، د کاروونکو شتمني بشپړه ساتنه کوي.',
    '全球化布局': 'نړیواله طرحه',
    '值得全球用户信赖': 'په 210+ هېوادونو او سیمو کې خدمت وړاندیز کوي، د نړۍ د کاروونکو په باور دی، تاسو ته اجازه ورکوي چې هرچیرې او هر وخت کریپټوکرنسي سوداګرۉ کې برخه واخلئ.',
    '多种币种': 'مختلف اسعار',
    '多种选择': 'مختلف انتخابونه',
    '全天交易量': '24 ساعته د سوداګرۉ حجم',
    '注册用户': 'ثبت شوي کاروونکي',
    "用户": "کاروونکي",
    '覆盖国家及地区': 'هېوادونه او سیمې چې پوښل شوي دي',
    '立即开启您的加密货币交易之旅': 'همالته خپله کریپټوکرنسي سوداګري پیل کړئ',
    '即刻开户': 'همالته حساب خلاص کړئ',
    '自动创建账户': 'د ایمیل/تلیفون په ثبتولو سره، اتومات حساب جوړیږي',
    '钱包充值': 'د والټ ډپازیت',
    '可随时为账户充值': 'تاسو کولی شئ هر وخت حساب ډپازیت کړئ، موږ د اصلي چینلونو ملاتړ کوو',
    '开始交易': 'سوداګري پیل کړئ',
    '然后开始交易': 'هغه سپټ یا تړون وټاکئ چې تاسو یې غواړئ، بیا سوداګري پیل کړئ',
    '关于我们': 'زموږ په اړه',
    '关于': 'په اړه',
    '使用者协议': 'د کارونکي تړون',
    '隐私政策': 'د محرمیت تګلاره',
    '支持': 'ملاتړ',
    '下载': 'ډاونلوډ',
    '帮助中心': 'د مرستې مرکز',
    '买币': 'اسعار واخلئ',
    '数字货币计算器': 'د ډیجیټل اسعارو کیلکولیټر',
    '购买': 'پیرل',
    '联系我们': 'موږ سره اړیکه ونیسئ',
    '社区': 'ټولنه',
    '搜寻': 'لټون',
    '此段落内的文章': 'په دې برخه کې مقالې',
    '简介': 'په لنډه',
    '更新于': 'اوسمهال',
    '我们的愿景': 'زموږ لید',
    '核心优势': 'اصلي برتري',
    '产品与服务': 'محصولات او خدمتونه',
    '我们的使命': 'زموږ ماموریت',
    'aboutText1': 'Crocodile بورس یو نړیوال مخکښ ډیجیټل شتمنیو تبادلې پلیټ فارم دی چې د نړۍ د کاروونکو لپاره د امن، اغیزمن او روښانه کریپټوکرنسي سوداګرۉ خدمتونه وړاندیز کوي. د صنعت په داخل کې د نوښت په توګه، Crocodile د پرمختللي بلاکچین ټیکنالوجۉ او مالي امنیتي سیسټمونو کاروي ترڅو د کاروونکو شتمني ساتنه وکړي، په ورته وخت کې روان او ثابت سوداګرۉ تجربه برابره کړي.',
    'aboutText2': 'د Crocodile بورس لید دا دی چې د نړۍ ترټولو باوري ډیجیټل شتمنیو تبادلې اکوسیستم جوړ کړي، چې د نوښت، مطابقت او ګڼ شمیر سوداګرۉ خدمتونه وړاندیز کوي، د بلاکچین ټیکنالوجۉ او ډیجیټل مالي پرمختګ ته وده ورکوي.',
    'aboutText3': 'د لوړې کچې امنیتي ساتنه: د بانکي کچې امنیتي سیسټم کاروي، ګڼ انکرپشن ټیکنالوجۉ او سړه/توده والټ جلا کول، د کاروونکو شتمني ساتنه کوي.',
    'aboutText4': 'اغیزمن معامله سیسټم: Crocodile د نړۍ مخکښ معامله سیسټم لري، چې د لوړې سرعت سوداګرۉ ملاتړ کوي، د سوداګرۉ روانتیا تضمین کوي.',
    'aboutText5': 'د ګڼو اسعارو ملاتړ: د Bitcoin (BTC)، Ethereum (ETH)، USDT او نورو اصلي او نوښتګر ډیجیټل شتمنیو سوداګري ملاتړ کوي.',
    'aboutText6': 'نړیوال مطابقت: د هېوادونو مالي قوانینو ته په پام سره، د مطابقت او روښانتیا تضمین کوي، د کاروونکو لپاره قانوني او مطابقت لرونکي ډیجیټل شتمني خدمتونه وړاندیز کوي.',
    'aboutText7': '24/7 مسلکي ملاتړ: د 24 ساعته ګڼ ژبي ملاتړ خدمتونه وړاندیز کوي، چې د کاروونکو ستونزې په چټکۉ حل کوي، د سوداګرۉ تجربه ښه کوي.',
    'aboutText8': 'سپټ سوداګري: د اصلي کریپټوکرنسي سوداګرۉ جوړې وړاندیز کوي، د ټیټ وخت او لوړ سیالۉ سره، د نوي او مسلکي سوداګرو لپاره مناسب دي.',
    'aboutText9': 'تړون سوداګري: لوړ لیورج، ټیټ سلیپج، د کاروونکو د انعطاف پذیر سوداګرۉ استراتیژۉ ملاتړ کوي.',
    'aboutText10': 'سټیکینګ او مالي: ګڼ شمیر عاید لرونکي محصولات وړاندیز کوي، چې د کاروونکو شتمني ته وده ورکوي.',
    'aboutText11': 'API سوداګري: د ادارو او کوانټ سوداګرو لپاره د لوړې کارکړې API انٹرفیس وړاندیز کوي، چې د مسلکي سوداګرۉ اړتیاوې پوره کوي.',
    'aboutText12': 'Crocodile بورس تل "کارونکي لومړي، امنیت لومړي، نوښت ته وده ورکول" په مرکزي ارزښتونو باوري دی، او د نړۍ د ډیجیټل شتمني سوداګرو لپاره یو اډی حل وړاندیز کوي. موږ باور لرو چې راتلونکی مالي سیسټم به د بلاکچین له خوا وړاندې شي، او Crocodile به د صنعت په وده کې مرسته وکړي، او د نړۍ د کاروونکو لپاره د عادلانه، اغیزمن او روښانه ډیجیټل مالي خدمتونه وړاندیز کړي.',
    'aboutText13': 'Crocodile بورس، راتلونکی مالي تاسو ته وړاندې کوي!',
    '已结束': 'پای ته رسیدلی',
    '分发总量': 'د ویش مجموعي مقدار',
    '个人兑换限额': 'د شخصي تبادلې حد',
    '最小投入量': 'د لږترلږه پانګه اچونه',
    '兑换价格': 'د تبادلې قیمت',
    'launchpad': "Crocodile Launchpad د یوې عالي بلاکچین نوې پروژې غوره پلیټ فارم دی چې کاروونکو ته اجازه ورکوي چې د پروژې په لومړي پړاو کې د مشهور پروژې ټوکنونه واخلي.",
    'launchpad1': "EchoLink د Solana بلاکچین پرته یو بلاکچین اوراکل دی چې د DePIN IoT وسیلو لپاره طراحی شوی. دا د ځانګړي ثبوت میکانزم له لارې مختلف IoT وسیلې سره نښلوي او پراخوي، د دوی د کار بار راټولوي، اندازه کوي او تاییدوي، او باوري ډیټا راپورونه تولیدوي. دا ډیټا د صفر پوهه ثبوت په کارولو سره انکرپټ کیږي او د اوراکل نوډونو ته لیږل کیږي، چې هرې وسیلې واحد ته د عاید ارزښت اندازه کوي. EchoLink د بشپړ سافټویر SDK او هارډویر ډیزاین سیټ هم وړاندیز کوي چې د نورو DePIN پروژو لپاره د بنسټیزې زیربنا په توګه کار کوي.",
    'launchpad2': "ACGN Protocol د AI چلول شوی Web3 ACGN (انیمیشن، کامیک، لوبې او ناول) د تخلیق کوونکو اکوسیستم دی. د ACGN Protocol په نوم د آزاد کوډ تخلیق کوونکي پروټوکول پر بنسټ، کاروونکي کولی شي زموږ د AI توکو په کارولو سره د اصلي IP څخه مشتقات مواد رامینځته کړي، د مشتقاتو او اصلي ترمنځ د NFT موادو شبکې ته وده ورکړي، او د ACGN موادو د تخلیق لاندې څخه پورته اکوسیستم جوړ کړي.",
    'launchpad3': "MetaExpand، چې د Universal Metaverse Expansion Protocol لنډیز دی (ټوکن نوم: UMM)، د میټاورس د عمومي پراختیا پروټوکول دی. MetaExpand د میټاورس اکوسیستم د بنسټیزې زیربنا په توګه کار کوي، چې د عامو بلاکچینونو او میټاورس غوښتنلیکونو ترمنځ د تخنیکي خلا په کچه کې د پام وړ کمښت راولي، د ذخیره، اړیکې، محرمیت، کراس چین او سوداګرۉ لپاره د بنسټیزو پلگینونو او د پراختیا معیارونو وړاندیز کوي، چې پراخوونکي ته اجازه ورکوي چې د لاندیني بلاکچین تخنیکي توپیرونو په اړه ډیر فکر ونه کړي؛ MetaExpand به د میټاورس بنسټیزو اجزاوو نمونه غوښتنلیکونه هم وړاندیز کړي، چې هم د عامو پلگینونو په توګه او هم د چټک پراختیا د پیل نقطې په توګه کارولی شي؛ MetaExpand د نورو اصلي عامو بلاکچینونو سره د مطابقت په توګه تعریف شوی دی، او د دوی د میټاورس اکوسیستم د پراختیا وړتیاوې ته وده ورکوي.",
    'launchpad4': "PINs یو موادي ټولنیز شبکه ده چې د ګڼ رول لوبولو په کارولو سره د پلاټ ډرایو شوي میټاورس رامینځته کوي او تاریخي او کلتوري خصوصیات ټولنې ته معرفي کوي. په PINs کې، ګڼ شمیر فصلونه شتون لري، چې هر یو یو مجازی نړۍ ته ورته دی، چې خلک کولی شي په ګڼ رولونو کې برخه واخلي او مختلف عملونه ترسره کړي.",
    'Launchpool1': 'زما Launchpool',
    'Launchpool2': 'Metaverse HQ (MVHQ) د لوبو، De-Fi، پروټوکولونو، تخلیق کوونکو، NFT/Memecoin ټولنو او غیرمتمرکز اکوسیستمونو لپاره د AI ډار شوي دندې پروټوکول دی. MVHQ د زنځیر په اوږدو کې د زنځیر باندې عایدونو لپاره د یو عام مرکز په توګه راڅرګند شوی دی، چې د میلیونونو ډالرو ارزښت کاروونکو ته ویشلي دی.',
    'Launchpool3': 'REVOX.AI د Web3 د شریک AI انٹرفیس جوړولو لپاره د خپل غیرمجاز ماشین زده کړې زیربنا په کارولو سره دی، چې د غیرمتمرکز AI غوښتنلیکونو پراختیا او نوښت ته وده ورکوي، او د ماډیولر هوښیار استازو پراخه کارونې ته مرسته کوي. د REVOX د بیرغ غوښتنلیکونه – Web3 GPT Lense، هوښیار والټ او ReadON DAO غوښتنلیک، په نړیواله کچه له 21 میلیونو کاروونکو څخه ډیر جذب کړي دي.',
    'Launchpool4': 'Cellula یو پروګرام کیدونکی هڅونې پوړ دی چې د مجازی کار ثبوت (vPOW) میکانزم په کارولو سره، د عادلانه شتمني ویش او د سیالۉ لارښوونې لپاره د نوښتګر لوبیزه خپرولو میتود کاروي. دا پروژه د Binance Labs او OKX Ventures لخوا ملاتړ شوې. د Cellula vPOW د "BitLife" موجوداتو ته ځانګړی هش ریټ ورکوي، چې دوی ته اجازه ورکوي چې د لوبیزه کیدونکي کان کیندنې پروسې کې برخه واخلي، چې دینامیک هڅونې تولیدوي. دا نوښتګره کان کیندنه انعطاف او پروګرام کیدونکي وړتیاوې معرفي کوي، چې Cellula ته اجازه ورکوي چې د بی سابقه عادلانه شتمني ویش او سیالۉ توزیع لارښوونه ترلاسه کړي – چې د EVM مطابقت لرونکي شبکه لپاره یو ریښتینی لومړی دی.',
    'Launchpool5': 'څنګه د LBank Launchpool کې برخه واخلئ',
    '全部': 'ټول',
    '报名中': 'په نوملیکنه کې',
    '预热中': 'په گرمیدو کې',
    '待发放': 'د توزیع په تمه',
    '标的币种': 'د هدف اسعار',
    '一键报名': 'یو کلیک نوملیکنه',
    '选择您感兴趣的项目并报名': 'هغه پروژې وټاکئ چې تاسو یې لیواله یاست او نوملیکنه وکړئ',
    '等待释放': 'د ازادیدو په تمه',
    '等待计算您将获得的代币数量': 'د هغو ټوکنونو د شمیرې په اړه چې تاسو به یې ترلاسه کړئ په تمه',
    '获得代币': 'ټوکنونه ترلاسه کړئ',
    '前往现货账户查看获得的代币': 'د سپټ حساب ته لاړ شئ ترڅو ترلاسه شوي ټوکنونه وګورئ',
    'locking1': 'ثابت سپټ، لوړ عاید، زړه آرام!',
    'locking2': 'د FLOKI سټیک کول د TOKEN ترلاسه کولو لپاره',
    '立即登录': 'همالته ننوتل',
    '项目名': 'د پروژې نوم',
    '年化收益率': 'کلنی عاید',
    '结算日期': 'د تسویې نیټه',
    '锁仓天数': 'د تړلو ورځې',
    '锁仓进度': 'د تړلو پرمختګ',
    '天': 'ورځ',
    '我要支付': 'زه تادیه کوم',
    '我将收到': 'زه به ترلاسه کړم',
    '购买数字货币': 'ډیجیټل اسعار واخلئ',
    'btc1': 'دا پاڼه د ډیجیټل اسعارو او فایټ اسعارو ترمنځ د ریښتینی وخت تبادلې نرخونه ښیي. د LBank له لارې، تاسو کولی شئ له 100 څخه ډیر مشهور ډیجیټل اسعار خپلې اړتیاوې پوره کولو لپاره فایټ اسعارو ته تبدیل کړئ. تاسو کولی شئ خپل غوره فایټ اسعار د ډیجیټل اسعارو شتمنیو ته هم تبدیل کړئ.',
    'btc2': 'د لومړیو 50 ډیجیټل اسعارو او فایټ اسعارو تبادلې نرخونه',
    '展开': 'پراخول',
    '收起': 'بندول',
    '数字货币': 'ډیجیټل اسعار',
    '轻松跟单': 'اسانه تعقیب، هوښیاره سوداګري',
    '顶级带单员': 'سرلیک لارښود',
    '全部带单员': 'ټول لارښودان',
    '最高收益率': 'ترټولو لوړ عاید',
    '获得最高收益率的带单员': 'هغه لارښودان چې ترټولو لوړ عاید ترلاسه کوي',
    '今日最佳': 'د نن ورځې غوره',
    '最高收益': 'ترټولو لوړ عاید',
    '赚取最高带单收益的带单员': 'هغه لارښودان چې ترټولو لوړ لارښود عاید ترلاسه کوي',
    '新晋带单员': 'نوي لارښودان',
    '最低回撤': 'ترټولو ټیټ بیرته راګرځیدنه',
    '交易风险最稳定的带单员': 'هغه لارښودان چې د سوداګرۉ خطر یې ترټولو ثابت دی',
    '最高跟随者收益': 'ترټولو لوړ تعقیب کوونکي عاید',
    '带领跟随者获得最高收益的带单员': 'هغه لارښودان چې خپلو تعقیب کوونکو ته ترټولو لوړ عاید ترلاسه کوي',
    '综合排名': 'جامع درجه بندي',
    '收益率': 'عاید',
    '胜率': 'د بریا کچه',
    '收益': 'عاید',
    '跟随者收益': 'د تعقیب کوونکو عاید',
    '最大回撤': 'اعظمي بیرته راګرځیدنه',
    '筛选': 'فلټر',
    '隐藏满员': 'بشپړ پټول',
    '更多': 'نور',
    '跟单': 'تعقیب',
    '空位提醒': 'د خالي ځای یادونه',
    '成为带单员': 'لارښود شئ',
    '跟单教程': 'د تعقیب لارښود',
    '跟单周动态': 'د تعقیب اونیزه خبرونه',
    '明星带单员': 'ستوري لارښودان',
    '产品更新与热门活动一览': 'د محصول تازه معلومات او مشهور فعالیتونه',
    '火箭团团长': 'د راکټ ډلې مشر',
    '总收益': 'ټول عاید',
    'copy1': 'تیرو 7 ورځو کې ترټولو ښه فعالیت لرونکي لارښودان',
    'copy2': 'د لوړ عاید او ټیټ بیرته راګرځیدنې سره نوي لارښودان',
    'help1': 'د شتمني ګیرول څه شی دی؟',
    'help2': 'د شتمني ګیرول هغه وخت دی چې تاسو د یوې سوداګرۉ په جریان کې یاست، پروسه لا بشپړه نه ده، او اوسنی شتمني د سیسټم لخوا لنډ وخت لپاره کنټرول کیږي، چې تاسو ته د آزادې کارونې وړ نه دي. دا په دې معنی نه ده چې ستاسو شتمني ورک شوې یا غیرعادي ده، نو تاسو آرام اوسئ.',
    'help3': 'د فیوچر سوداګرۉ قواعد څه دي؟',
    'help4': 'د اوسني سوداګرۉ جوړې راتلونکي قیمت حرکت (لوړیدل یا کموالي) اټکل کولو سره سوداګري کوي. په تسویه کې د لوړیدو یا کموالي حساب نه کیږي، یوازې د دوی ګټه حساب کیږي. د مختلف تسویه وختونو لپاره د ګټې سلنه توپیر لري، او ګټه به په سوداګرۉ انٹرفیس کې دقیقه ښکاره شي.',
    'help5': 'د شتمني ډپازیت یا راوړلو لپاره اړین USDT مقدار څنګه تبدیل کړئ؟',
    'help6': 'د شتمني ډپازیت یا راوړلو مقدار د هغه اسعار/USDT په ریښتینی وخت قیمت کې بدلون مومي چې تاسو یې کاروئ. په حقیقت کې ستاسو شتمني بدلون نه کوي.',
    'help7': 'د سوداګرۉ پټنګه هیر شوې؟',
    'help8': 'که تاسو د سوداګرۉ پټنګه هیرې کړې، تاسو کولی شئ د ["شخصي مرکز"] په اوږدو کې ["امنیتي مرکز"] ["سوداګرۉ پټنګه"] کلیک وکړئ ترڅو یې تغیر کړئ. ځانګړي ګامونه لاندې دي:',
    'help9': '1. که تاسو تلیفون شمیره تړلې وي، د تلیفون د تایید کوډ اړتیا لرئ',
    'help10': '2. که تاسو ایمیل تړلې وي، د ایمیل د تایید کوډ اړتیا لرئ',
    'help11': '3. نوی سوداګرۉ پټنګه ولیکئ',
    'help12': '4. نوی سوداګرۉ پټنګه تایید کړئ',
    'help13': '5. ["سپارل"] کلیک وکړئ',
    'help14': 'د ننوتلو پټنګه هیر شوې؟',
    'help15': 'که تاسو د ننوتلو پټنګه هیرې کړې، تاسو کولی شئ د ["ننوتلو پاڼې"] ["پټنګه هیر شوې؟"] ته لاړ شئ ترڅو د ایمیل یا تلیفون تایید کوډ ترلاسه کړئ، او نوی ننوتلو پټنګه تنظیم کړئ.',
    'help16': 'څنګه د حساب امنیت ښه کړئ؟',
    'help17': 'د خپل حساب لپاره یو ډیر پیچلی او خوندي پټنګه جوړه کړئ، او خپل شخصي معلومات له چا سره شریک نه کړئ.',
    'protocol1': 'دا ویبسایټ یو پلیټ فارم دی چې د بهرنۍ اسعارو او ډیجیټل شتمنیو سوداګرۉ او اړوند خدمتونو ته وقف شوی دی (په دې تړون کې "خدمت" یا "خدمتونه" بلل کیږي). د دې تړون د اسانتیا لپاره، دا ویبسایټ په دې تړون کې "موږ" یا نور لومړي شخص شرایط کاروي. د دې تړون د اسانتیا لپاره، "تاسو" یا نور دوهم شخص شرایط کارول کیږي. د دې تړون د اسانتیا لپاره، موږ او تاسو په دې تړون کې په ګډه "دواړه خواوې" بلل کیږي، او موږ یا تاسو په جلا توګه "یوه خوا" بلل کیږي.',
    'protocol2': 'مهم یادونه:',
    'protocol3': 'موږ دلته تاسو ته ځانګړی یادونه کوو:',
    'protocol4': 'ډیجیټل شتمني په اصلي ډول له هیڅ مالي مؤسسې یا شرکت یا دې ویبسایټ څخه نه دي خپرې شوې؛',
    'protocol5': 'ډیجیټل شتمني بازار نوی، ناتایید شوی او ممکن وده ونه کړي؛',
    'protocol6': 'ډیجیټل شتمني په عمده توګه د سوداګرو لخوا کارول کیږي، او په خرده او سوداګریزو بازارونو کې د کارونې نسبتاً لږ دی. دا ټولې ورځې سوداګري کیږي، او د قیمت لوړیدو او کموالي هیڅ حد نه لري، او قیمت یې د بازار جوړونکو او نړیوالو حکومتي',
    "下载App": "اپلیکیشن را دانلود کنید",
    "扫描并下载": "اسکن کرده و دانلود کنید",
    "全球": "جهانی",
    "顶尖": "برتر",
    "加密货币": "ارزهای دیجیتالی",
    "交易平台": "پلتفرم معاملاتی",
    "使用美元买入Bitcoin、Ethereum和多种加密货币": "با دلار آمریکا بیت‌کوین، اتریوم و سایر ارزهای دیجیتالی را خریداری کنید",
    "通过加密货币、电汇等多种方式存入资金*": "واریز وجه از طریق روش‌های مختلف شامل ارزهای دیجیتالی، حواله بانکی و...*",
    "業界領先的法遵與資安認證": "گواهی‌های امنیتی و انطباق پیشرو در صنعت",
    "深受全球 1 億以上用戶信賴": "مورد اعتماد بیش از ۱۰۰ میلیون کاربر در سراسر جهان"
}
